import { render, staticRenderFns } from "./Template2.vue?vue&type=template&id=698b8272&scoped=true&"
import script from "./Template2.ts?vue&type=script&lang=ts&"
export * from "./Template2.ts?vue&type=script&lang=ts&"
import style0 from "./Template2.vue?vue&type=style&index=0&id=698b8272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698b8272",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VFadeTransition,VForm,VIcon,VTextField})
